<template>
    <div class="main-box mh-a p20">
        <div v-if="page=='behavioral'">
            <h4 class="text-left fs24 mb20 mt20">{{ $t("service.behavioral")}} </h4>
            <div class="flex mt25">
                <div class="flex1">
                    <h4 class="fs20">{{ $t("service.t1")}}</h4>
                     <div class="mt10">
                        <img src="/static/img/product/a1.jpg" alt="">
                    </div>
                </div>
                  <div class="flex1">
                    <h4 class="fs20 ">{{ $t("service.t2")}}</h4>
                     <div class="mt10 text-center mb20">
                        <img src="/static/img/product/a2.jpg" alt="">
                    </div>
                     <h4 class="fs20">{{ $t("service.t3")}}</h4>
                     <div class="mt10 text-center">
                        <img src="/static/img/product/a3.png" alt="">
                    </div>
                </div>
            </div>
        </div>
         <div v-if="page=='flow'">
              <h4 class="text-left fs24 mb20 mt20">{{ $t("service.flow")}} </h4>
              <div class="mt10 text-center">
                  <img src="/static/img/product//flow.png" alt="">
              </div>
        </div>
    </div>
</template>

<script>
// import IristarDividing from "@/components/IristarDividing";
// import ProductList from "@/assets/product/productList";
// import ProductListEn from "@/assets/product/productList-en";
export default {
    name: "ProductDetial",
    computed: {
        // productDetial() {
        //     let list =
        //         this.$store.state.language === "zh"
        //             ? ProductList
        //             : ProductListEn;
        //     let detialArr = list.filter((item) => {
        //         return item.type == this.$route.params.index;
        //     });
        //     return detialArr[0];
        // },
    },
    data(){
        return {
            page:''
        }
    },
    watch:{
        '$route.params.index':function(){
            this.page= this.$route.params.index ;
        }
    },
    components: {
    },
    mounted(){
        this.page= this.$route.params.index ;
    }
};
</script>

<style lang="less">

</style>